module.exports = __webpack_public_path__ + "img/117.b7479471.jpg";